import { checkRequiredAreNotEmpty } from '../lib/helpers'
import axios from 'axios'

export default{
  namespaced: true,
  state:{
    urls:{},
    current:{
      name: '',
      slug: '',
      disabled: false,
      allow_lead_modifications: false,
      export_details_ats: false,
      field_keys: {},
      rules: {},
      extra_rules: {},
      resources: {},
      information: {},
      screenshots: {},
    },
    saving: false,
    loading: false,
    error: {
      error: false,
      message: '',
      code: ''
    }
  },
  mutations:{
    ERROR(state, {message, code}){
      state.error = {
        error: true,
        message: message,
        code: code
      };
    },
    LOADING(state, bool){
      state.loading = bool;
    },
    SAVING(state, bool){
      state.saving = bool;
    },
    SET_URLS(state, urls){
      state.urls = urls;
    },
    UPDATE_CURRENT(state, newCurrent){
      if(!newCurrent.hasOwnProperty('rules')) newCurrent.rules = state.current.rules;
      if(!newCurrent.hasOwnProperty('field_keys')) newCurrent.field_keys = state.current.field_keys;
      if(!newCurrent.hasOwnProperty('resources')) newCurrent.resources = state.current.resources;
      if(!newCurrent.hasOwnProperty('information')) newCurrent.information = state.current.information;
      state.current = newCurrent;
    },
    UPDATE_CURRENT_RULES_FOR_KEY(state, {key, value}){
      // Save proper booleans
      if(value === 'true') value = true;
      if(value === 'false') value = false;
      Vue.set(state.current.rules, key, value);
    },
    REMOVE_PROP_FROM_RULES(state, key){
      Vue.delete(state.current.rules, key);
    },
    UPDATE_CURRENT_EXTRA_RULES_FOR_KEY(state, {key, value}){
      // Save proper booleans
      if(value === 'true') value = true;
      if(value === 'false') value = false;
      Vue.set(state.current.extra_rules, key, value);
    },
    REMOVE_PROP_FROM_EXTRA_RULES(state, key){
      Vue.delete(state.current.extra_rules, key);
    },
    UPDATE_CURRENT_FIELD_KEYS_FOR_KEY(state, {key, value}){
      // Save proper booleans
      if(value === 'true') value = true;
      if(value === 'false') value = false;
      Vue.set(state.current.field_keys, key, value);
    },
    REMOVE_PROP_FROM_FIELD_KEYS(state, key){
      Vue.delete(state.current.field_keys, key);
    },
    UPDATE_CURRENT_RESOURCES_FOR_KEY(state, {key, value}){
      // Save proper booleans
      if(value === 'true') value = true;
      if(value === 'false') value = false;
      Vue.set(state.current.resources, key, value);
    },
    REMOVE_PROP_FROM_RESOURCES(state, key){
      Vue.delete(state.current.resources, key);
    },
    UPDATE_CURRENT_INFORMATION_FOR_KEY(state, {key, value}){
      // Save proper booleans
      if(value === 'true') value = true;
      if(value === 'false') value = false;
      Vue.set(state.current.information, key, value);
    },
    REMOVE_PROP_FROM_INFORMATION(state, key){
      Vue.delete(state.current.information, key);
    },
  },
  actions:{
    save({state, commit}){

      commit('SAVING', true);
      let data = state.current;

      axios.post(state.urls.submissionUrl, data)
        .then(response => {
          if(response.data.success){
            window.location = response.data.redirect;
          }else{
            commit('ERROR', {
              message: `Not saved! Please refresh page and try again`,
              code: `${response.status}: ${response.statusText}`
            });
          }
        })
        .catch(error => {
          commit('SAVING', false);
          commit('ERROR', {
            message: `Not saved! Please refresh page and try again`,
            code: error
          });
        });
    },
  }
}
